import React, { useState, useEffect, useRef } from "react";
import { registerLocale } from "react-datepicker";
import DatePicker from "../../../components/DatePickerInput";
import Label from "./LabelF";
import "react-datepicker/dist/react-datepicker.css";
//import "../filtros.scss";
import ar from "date-fns/locale/es";
import {
  parseISOString,
  getAtributo,
  parseHoraString,
} from "../../../context/FuncionesContext";

import {
  validaFormatoFecha,
  validaFormatoHora,
  parseFechaFormato,
} from "../../../helper/funciones";
import Nullifier from "../../../components/Nullifier";

import { TextField } from "@mui/material";
registerLocale("ar", ar);

export function transformarFechaISOaMySQL(fechaISO, fecha_formato = "") {
  // de formato de DatePicker a formato MySQL
  try {
    const regexHora = /^([01]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/;
    const regexFechaHora =
      /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})(?::(\d{2}))?(?:\.(\d{1,3}))?(?:Z|[+-]\d{2}:?\d{2})?$/;
    const regexFecha = /^\d{4}-\d{2}-\d{2}$/;

    const formato = (fecha_formato ?? "").trim();
    const esSoloFecha = formato !== "" && !/[Hhms]/.test(formato);

    const pad = (n, len = 2) => String(n).padStart(len, "0");
    const formatearDateLocal = (date) => {
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate(),
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds(),
      )}.${pad(date.getMilliseconds(), 3)}`;
    };

    if (typeof fechaISO === "string" && regexHora.test(fechaISO)) {
      let [hora, minuto, segundo] = fechaISO.split(":");

      hora = hora.padStart(2, "0");
      minuto = minuto.padStart(2, "0");
      segundo = segundo ? segundo.padStart(2, "0") : "00";

      return `1969-01-01 ${hora}:${minuto}:${segundo}.000`;
    }

    if (fechaISO === null || fechaISO === undefined || fechaISO === "") {
      return null;
    }

    if (esSoloFecha) {
      if (fechaISO instanceof Date) {
        if (Number.isNaN(fechaISO.getTime())) return null;
        return formatearDateLocal(fechaISO);
      }

      if (typeof fechaISO === "string") {
        const fechaTexto = fechaISO.trim();

        if (regexFecha.test(fechaTexto)) {
          return `${fechaTexto} 00:00:00.000`;
        }

        const matchFechaHora = fechaTexto.match(regexFechaHora);
        if (matchFechaHora) {
          const [, soloFecha, hhmm, ss = "00", ms = "000"] = matchFechaHora;
          return `${soloFecha} ${hhmm}:${ss.padStart(2, "0")}.${ms.padEnd(
            3,
            "0",
          )}`;
        }
      }

      const fechaLocal = new Date(fechaISO);
      if (Number.isNaN(fechaLocal.getTime())) return null;
      return formatearDateLocal(fechaLocal);
    }

    if (isNaN(Date.parse(fechaISO))) return null;

    const fechaUTC = new Date(fechaISO);
    const fecha = new Date(fechaUTC.getTime() - 3 * 60 * 60 * 1000);
    const fechaMySQL = fecha
      .toISOString()
      .replace("T", " ")
      .replace("Z", "")
      .trim();

    return fechaMySQL;
  } catch (er) {
    console.log(er, fechaISO);
    return fechaISO;
  }
}

const esFechaPosteriorAHoy = (fecha) => {
  if (!(fecha instanceof Date) || Number.isNaN(fecha.getTime())) {
    return false;
  }

  const fechaSeleccionada = new Date(fecha);
  const hoy = new Date();

  fechaSeleccionada.setHours(0, 0, 0, 0);
  hoy.setHours(0, 0, 0, 0);

  return fechaSeleccionada > hoy;
};

const FechaSimple = (props) => {
  const { setValor, valor, grid_span, error, setError, cab, data, modoAlta } =
    props;

  const def = data[cab.id_a + "_default"] ?? cab.default;
  const { id_a } = cab;

  const fecha_formato = (() => {
    if (props.fecha_formato && props.fecha_formato !== "")
      return props.fecha_formato;
    return cab.fecha_formato ?? "dd/MM/yyyy";
  })();

  useEffect(() => {
    let mydefault = data[cab.id_a + "_default"] ?? cab.default;
    if (modoAlta) {
      setValor(transformarFechaISOaMySQL(mydefault, fecha_formato));
    }
  }, []);

  const permite_null =
    data[cab.id_a + "_permite_null"] === "s" || cab.permite_null === "s";

  const fechaMayorALaActual =
  data[cab.id_a + "_fecha_mayor_a_la_actual"] ??
  cab.fecha_mayor_a_la_actual ??
  "s";

const restringeFechaFutura = fechaMayorALaActual === "n";

  const [fecha, setFecha] = useState("");
  const usuarioModificoFecha = useRef(false);

  const styles = {
    gridColumn: grid_span,
  };

  useEffect(() => {
    const tieneValor = valor !== null && valor !== undefined && valor !== "";

    if (tieneValor) {
      if (validaFormatoHora(valor)) {
        return setFecha(parseHoraString(valor));
      }
      return setFecha(parseISOString(valor));
    }

    if (usuarioModificoFecha.current) return setFecha(null);

    if (modoAlta && validaFormatoFecha(def)) {
      const defaultNormalizado = transformarFechaISOaMySQL(def, fecha_formato);
      return setFecha(parseISOString(defaultNormalizado));
    }
    if (modoAlta && validaFormatoHora(def)) {
      return setFecha(parseHoraString(def));
    }
    setFecha(null);
  }, [def, modoAlta, valor, fecha_formato]);

  const handleChange = (date) => {
    if (!permite_null && date === null) return;

    if (restringeFechaFutura && esFechaPosteriorAHoy(date)) {
      return;
    }

    usuarioModificoFecha.current = true;
    setFecha(date);
    setError((e) => {
      return { ...e, [id_a]: false };
    });

    setValor(transformarFechaISOaMySQL(date, fecha_formato));
  };

  const disabled = getAtributo("disabled", data, cab) === "s";

  const {
    showTimeSelect,
    showTimeSelectOnly,
    timeFormat,
    dateFormat,
    timeIntervals,
  } = parseFechaFormato(fecha_formato);

  const placeholder = cab.placeholder ?? cab.fecha_formato;
  const ancho = `${placeholder?.length + 3}ch`;

  return (
    <div style={styles}>
      <div
        className="filtro_grid_fecha"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Label
          label={cab.nombre}
          opcionales_null={cab.opcionales_null}
          permite_null={cab.permite_null}
        />

        <div
          style={{ display: "flex", alignItems: "center", gap: "4px" }}
          className={`${cab.input_class_caja ?? ""} fecha_simple_datepicker`}
        >
          <div style={{ width: ancho, flexShrink: 0 }}>
            <DatePicker
              showTimeSelect={showTimeSelect}
              showTimeSelectOnly={showTimeSelectOnly}
              timeFormat={timeFormat}
              dateFormat={dateFormat}
              timeIntervals={timeIntervals}
              timeCaption="Hora"
              locale="ar"
              selected={fecha}
              value={fecha}
              fechaMinima={getAtributo("fecha_minima", data, cab)}
              maxDate={restringeFechaFutura ? new Date() : undefined}
              scrollableYearDropdown
              showYearDropdown={true}
              placeholderText={cab.placeholder ?? cab.fecha_formato}
              onChange={handleChange}
              customInput={
                <TextField
                  fullWidth
                  className={error[id_a] ? "filtro_fecha_input_error" : "w-100"}
                  label={
                    cab.label && cab.label.trim() !== ""
                      ? cab.label
                      : undefined
                  }
                  inputProps={{
                    className: cab.input_class_text,
                  }}
                />
              }
              autoComplete="off"
              disabled={disabled}
            />
          </div>

          {permite_null ? (
            <div style={{ flexShrink: 0 }}>
              <Nullifier
                onClick={() => handleChange(null)}
                className="columna_input_date_null"
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default FechaSimple;
